// MODULES
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { HomeModule } from "./module/home/home.module";
import { DashboardModule } from "./module/dashboard/dashboard.module";
import { AlarmModule } from "./module/alarm/alarm.module";
import { AlarmaModule } from "./module/alarma/alarma.module";
import { OrdersModule } from "./module/orders/orders.module";
import { GunningsModule } from "./module/gunnings/gunnings.module";
import { TundishModule } from "./module/tundish/tundish.module";
import { IncidentsModule } from "./module/incidents/incidents.module";
import { MapaModule } from "./module/mapa/mapa.module";
// import { LoginModule } from "./module/login/login.module";
import { MaterialModule } from "./module/material/material.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DeviceStatusModule } from "./module/device-status/device-status.module";
import { LatestMeasurementsModule } from "./module/latest-measurements/latest-measurements.module";
import { LastStatesModule } from "./module/last-states/last-states.module";
import { ComparativeGraphsModule } from "./module/comparative-graphs/comparative-graphs.module";
import { CheckMeasurementsProductsModule } from "./module/check-measurements-products/check-measurements-products.module";
import { GraphicsModule } from "./module/graphics/graphics.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { StorageModule } from "@ngx-pwa/local-storage";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DispositivosModule } from "./module/dispositivos/dispositivos.module";
import { SharedModuleModule } from "./module/shared-module/shared-module.module";
import { ToastrModule } from "ngx-toastr";
import "./models/array-prototype.model";

import { MatDialogModule } from "@angular/material/dialog";
import { NgxPaginationModule } from "ngx-pagination";
import { ClipboardModule } from "ngx-clipboard";
import { FilterPipeModule } from "ngx-filter-pipe";
import { SelectDropDownModule } from "ngx-select-dropdown";
import { NgxSpinnerModule } from "ngx-spinner";

import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { RealTimeModule } from "./module/real-time/real-time.module";

// TRANSLATE
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClient,
  HttpClientModule,
  HttpErrorResponse,
} from "@angular/common/http";

// GRAPHQL
import { ApolloModule, APOLLO_OPTIONS } from "apollo-angular";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
//import { GraphQLModule } from "./graphql.module";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import {
  ApolloClientOptions,
  NormalizedCacheObject,
  split,
} from "@apollo/client/core";
import { createClient } from "graphql-ws";

// COMPONENTS
import { AppComponent } from "./app.component";
import { SidebarComponent } from "./components/shared/sidebar/sidebar.component";
import { FooterComponent } from "./components/shared/footer/footer.component";
import { DashboardComponent } from "./sections/dashboard/dashboard.component";
import { BbddComponent } from "./sections/bbdd/bbdd.component";

import { PagenotfoundComponent } from "./components/shared/pagenotfound/pagenotfound.component";
// import { AngularFontAwesomeModule } from "angular-font-awesome";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { GraphicsComponent } from "./sections/visualizacionFolder/graphics/graphics.component";
import { DeviceStatusComponent } from "./sections/visualizacionFolder/device-status/device-status.component";
import { LatestMeasurementsComponent } from "./sections/visualizacionFolder/latest-measurements/latest-measurements.component";
import { LastStatesComponent } from "./sections/visualizacionFolder/last-states/last-states.component";
import { ComparativeGraphsComponent } from "./sections/visualizacionFolder/comparative-graphs/comparative-graphs.component";
import { CheckMeasurementsProductsComponent } from "./sections/visualizacionFolder/check-measurements-products/check-measurements-products.component";
import { DispositivosComponent } from "./sections/dispositivos/dispositivos.component";
import { InformesComponent } from "./components/informes/informes.component";
import { InformeFabricaComponent } from "./components/informes/informe-fabrica.component";
import { InformeMaeComponent } from "./components/informes/informe-mae.component";
import { PopUpComponent } from "./components/utilidades/ventana-dsp/pop-up.component";
import { ReportParamComponent } from "./components/informes/ventanas/fabrica/report-param/report-param.component";
import { ReportRowComponent } from "./components/informes/ventanas/fabrica/report-row/report-row.component";
import { NavegacionDependenciasComponent } from "./components/navegacion-dependencias/navegacion-dependencias.component";
import { EstructuraCampoComponent } from "./sections/estructuraCampo/estructuraCampo.component";
import { EstructuraCampoNavComponent } from "./components/estructuraCampoNav/estructuraCampoNav.component";
import { ReportTableComponent } from "./components/informes/ventanas/fabrica/report-table/report-table.component";
import { GraphFunciones } from "./components/informes/consultas/consultas-graphql.service";
import { GraphFuncionesFabrica } from "./components/informes/consultas/fabrica/consultas-graphql.service";
import { GraphFuncionesMae } from "./components/informes/consultas/mae/consultas-graphql.service";
import { IridiumeRequestModalComponent } from "./components/iridium-events/iridium-request-modal/iridium-request-modal.component";
import { OrdersComponent } from "./sections/orders/orders.component";
import { OrdersModalComponent } from "./sections/orders/modal/orders-modal.component";
import { EditOTModalComponent } from "./sections/orders/modal/editOT/editOTmodal.component";

// PIPES
import { SelectPipeBBDD } from "src/app/pipes/pipes/pipe-iker-map.pipe";
import { GetUtcDatePipe } from "src/app/pipes/pipes/pipe-utcDate.pipe";
import { ToFixedPipe } from "src/app/pipes/tofixed.pipe";
import { GetAlarmaCampoPipe } from "src/app/pipes/alarmaCampo.pipe";
import { ToTitlePipe } from "./pipes/pipes/string-to-title.pipe";
import { AlarmsComponent } from "./sections/alarms/alarms.component";
import { AlarmasComponent } from "./sections/alarmas/alarmas.component";

// SERVICES
import { LocalstorageService } from "./services/localstorage/localstorage.service";
import { ApolloGraphQlService } from "./services/apollo/apollo-graphql.service";
import { LoginComponent } from "./sections/login/login.component";
import { HomeComponent } from "./sections/home/home.component";
import { FactoriesService } from "./services/factories/factories.service";
import { environment } from "src/environments/environment";
import { arbolDispositivos } from "./services/arbolDispositivos/arbolDispositivos.component";
import { arbolDatos } from "./components/arbolDatos/arbolDatos.component";
import { UsersComponent } from "./sections/users/users.component";
import { EntradasNavComponent } from "./components/entradas-nav/entradas-nav.component";
import { MapaComponent } from "./sections/mapa/mapa.component";
import { NoCredentialsComponent } from "./components/noCredentials/no-credentials.component";
import { CookieService } from "ngx-cookie-service";
//import { BillboardLayerDevicesComponent} from './components/mapa/billboard-layer-devices/billboard-layer-devices.component';

import { take } from "rxjs/operators";
import { LoginService } from "./services/login/login.service";
import { Subscription } from "rxjs";

import { IridiumEventsComponent } from "./components/iridium-events/iridium-events.component";
import { UltimasMedicionesModule } from "./module/ultimas-mediciones/ultimas-mediciones.module";
import { InformesTablesComponent } from "./components/informes/informes/informes-tables/informes-tables.component";
import { StatusModule } from "./module/status/status.module";
import { TablasComponent } from "./sections/tablas/tablas.component";
import { TablasFormComponent } from "./sections/tablas/tablas-form/tablas-form.component";
import { DynamicFormControlComponent } from "./sections/tablas/tablas-form/dynamic-form/dynamic-form-control.component";
import { ColumnTreeComponent } from "./sections/tablas/tree-view/column-tree/column-tree.component";
import { NodeAlarmComponent } from "./components/node-alarm/node-alarm.component";
import { NodeAlarmInfoComponent } from "./components/node-alarm-info/node-alarm-info.component";

import { EstructuraCampoAdminComponent } from "./sections/estructura-campo-admin/estructura-campo-admin.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { EditNodeComponent } from "./components/edit-node/edit-node.component";

import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_FORMATS,
} from "ng-pick-datetime";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { StatusComponent } from "./sections/status/status.component";
import { HttpLink } from "apollo-angular/http";
import { NgChartsModule } from "ng2-charts";
import { AngularCesiumModule } from "angular-cesium";
import { AngularCesiumWidgetsModule } from "angular-cesium";
import { Swhc3dModule } from "./module/swhc3d/swhc3d.module";
import { create } from "lodash";
import { InMemoryCache } from "@apollo/client/core";
import { GraphQLModule } from "./graphql.module";

export const MY_MOMENT_FORMATS = {
  parseInput: "DD/MM/YYYY HH:mm:ss",
  fullPickerInput: "DD/MM/YYYY HH:mm:ss",
  datePickerInput: "DD/MM/YYYY",
  timePickerInput: "HH:mm:ss",
  monthYearLabel: "MMM YYYY",
  dateA11yLabel: "LL",
  monthYearA11yLabel: "MMMM YYYY",
};

interface Definintion {
  kind: string;
  operation?: string;
}

@NgModule({
  declarations: [
    //TODO: Revisar estos componentes
    // JSON.parse(environment.iridium) === true ? IridiumEventsComponent : [],
    // JSON.parse(environment.tables) === true ? TablasComponent : [],
    NoCredentialsComponent,
    EstructuraCampoNavComponent,
    EstructuraCampoComponent,
    // ToFixedPipe,
    GetUtcDatePipe,
    GetAlarmaCampoPipe,
    ToTitlePipe,
    AppComponent,
    FooterComponent,
    // DashboardComponent,
    PagenotfoundComponent,
    // GraphicsComponent,
    AlarmsComponent,
    // OrdersComponent,
    // AlarmasComponent,
    UsersComponent,
    LoginComponent,
    HomeComponent,
    SidebarComponent,
    DeviceStatusComponent,
    LatestMeasurementsComponent,
    LastStatesComponent,
    ComparativeGraphsComponent,
    CheckMeasurementsProductsComponent,
    // IdiomaComponent,
    // DispositivosComponent,
    BbddComponent,
    arbolDispositivos,
    SelectPipeBBDD,
    arbolDatos,
    InformesComponent,
    InformeFabricaComponent,
    InformeMaeComponent,
    PopUpComponent,
    ReportParamComponent,
    ReportRowComponent,
    NavegacionDependenciasComponent,
    ReportTableComponent,
    EntradasNavComponent,
    //MapaComponent,
    //BillboardLayerDevicesComponent,
    IridiumEventsComponent,
    IridiumeRequestModalComponent,
    InformesTablesComponent,
    TablasComponent,
    TablasFormComponent,
    DynamicFormControlComponent,
    ColumnTreeComponent,
    NodeAlarmComponent,
    NodeAlarmInfoComponent,
    OrdersModalComponent,
    EditOTModalComponent,
    EstructuraCampoAdminComponent,
    EditNodeComponent,
  ],
  entryComponents: [
    PopUpComponent,
    ColumnTreeComponent,
    ReportParamComponent,
    ReportRowComponent,
    ReportTableComponent,
    NavegacionDependenciasComponent,
    DispositivosComponent,
    IridiumeRequestModalComponent,
    NodeAlarmComponent,
    OrdersModalComponent,
    EditOTModalComponent,
    EditNodeComponent,
  ],
  imports: [
    GraphQLModule,
    NgSelectModule,
    MatExpansionModule,
    ClipboardModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    SelectDropDownModule,
    FilterPipeModule,
    NgxPaginationModule,
    MatDialogModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    SharedModuleModule,
    // LoginModule,
    HomeModule,
    // DashboardModule,
    // DispositivosModule,
    AlarmModule,
    // AlarmaModule,
    OrdersModule,
    GunningsModule,
    TundishModule,
    IncidentsModule,
    StatusModule,
    MapaModule,
    FontAwesomeModule,
    NgbModule,
    DeviceStatusModule,
    LatestMeasurementsModule,
    LastStatesModule,
    ComparativeGraphsModule,
    CheckMeasurementsProductsModule,
    // GraphicsModule,
    NgxSpinnerModule,
    HttpClientModule,
    NgxDatatableModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ApolloModule,
    FormsModule,
    ReactiveFormsModule,
    StorageModule.forRoot({
      IDBNoWrap: true,
    }),
    ToastrModule.forRoot({
      positionClass: "toast-top-right",
      preventDuplicates: false,
    }),
    MatFormFieldModule,
    MatButtonModule,
    UltimasMedicionesModule,
    MatDatepickerModule,
    NgChartsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    RealTimeModule,
    NgMultiSelectDropDownModule.forRoot(),
    AngularCesiumModule.forRoot(),
    AngularCesiumWidgetsModule,
    Swhc3dModule,
  ],
  providers: [
    ApolloGraphQlService,
    LocalstorageService,
    FactoriesService,
    GraphFunciones,
    GraphFuncionesFabrica,
    GraphFuncionesMae,
    CookieService,
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.i18nPath);
}
